module.exports = __webpack_public_path__ + "media/images/starworksKids-logo-cf31877bc14b1dedb36fb53030a96986.svg";